(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6651],{

/***/ 66739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started",
      function () {
        return __webpack_require__(67722);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ getting_started; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(6435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(78344);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(42554);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
;// CONCATENATED MODULE: ./views/getting-started/getting-started-page.tsx









var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            display: "flex",
            justifyContent: "center",
            flexGrow: 1,
            height: "100%"
        },
        grid: {
            alignSelf: "center",
            textAlign: "left"
        },
        getStartedImage: {
            width: "100%",
            borderRadius: "10px"
        },
        button: {
            marginTop: theme.spacing(2)
        }
    };
});
function GettingStartedPage() {
    var classes = useStyles().classes;
    var t = (0,useTranslation/* useTranslation */.$)([
        "shared",
        "gettingStarted"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            className: classes.grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: classes.getStartedImage,
                            src: "/images/getting-started.png"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    className: classes.grid,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                align: "left",
                                children: t([
                                    "gettingStarted:liveDataAnywhere"
                                ], {
                                    defaultValue: "Live data, anywhere"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                align: "left",
                                children: t([
                                    "gettingStarted:letsUsGuideYou"
                                ], {
                                    defaultValue: "First time using Blackbird? Let us guide you through it."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                                href: {
                                    pathname: "/getting-started/learn"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    className: classes.button,
                                    children: t([
                                        "gettingStarted:getStarted"
                                    ], {
                                        defaultValue: "Get Started"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/getting-started/index.tsx


var GettingStarted = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedPage, {});
};
var __N_SSG = true;
/* harmony default export */ var getting_started = (GettingStarted);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(66739); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);